import $ from 'jquery';

export const resetPasswordValue = (() => {
	$(document).on('focus', '[type="password"]', ev => {
        ev.preventDefault();
        let target = $(ev.currentTarget);
		target.val('');
	});
})();
